import { useEffect, useState } from "react";
import { app, auth, uiConfig, userHelper, userReducer } from "@tiffin/app-common";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { AccountInfoModal } from "../account/AccountInfoModal";

import { StyledFirebaseAuth } from "react-firebaseui";
import { Modal } from "antd";
import { Loading } from "@tiffin/components";

interface IAccountModal {
  className?: string,
  isOpen: boolean,
  onClose: () => void,
  onSuccess: () => void,
  userDetails?: {
    firstName: string,
    lastName: string,
    email: string,
    phonePrefix: string,
    phone: string,
  }
}

export function AccountModal({isOpen, onClose, onSuccess, userDetails}: IAccountModal) {

  const [showProfileModal, setShowProfileModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [signInProcess, setSignInProcess] = useState(false)

  const authenticate = useAppSelector((state) => state.authenticate)

  const dispatch = useAppDispatch()

  const webUiConfig = uiConfig;

  useEffect(() => {
    if(signInProcess) {
      if(authenticate.status === "authenticated") {
        userHelper.notifyWhenStripeCustomerIdAssigned(() => {
          setSignInProcess(false)
          setLoading(false)
          onSuccess()
        })
        setShowProfileModal(false)
        setLoading(true)
      } else if(authenticate.status === "incomplete") {
        setShowProfileModal(true)
      } else if(authenticate.status === "unauthenticated") {
        setShowProfileModal(false)
      }
    }
  }, [authenticate.status, signInProcess])

  return (
    <>
      <Loading isOpen={loading} showBox={true} message="Creating account" />
      <Modal
        open={isOpen}
        onCancel={() => {
          onClose()
        }}
        footer={[]}
        destroyOnClose={true}
      >
        <StyledFirebaseAuth
          className={`${auth.currentUser?.phoneNumber ? 'lock-phone-input' : ''}`}
          uiConfig={{
            ...webUiConfig,
            callbacks: {
              signInSuccessWithAuthResult: () => {
                onClose()
                setSignInProcess(true)
                return false;
              }
            }
          }}
          firebaseAuth={app.auth()}
        />
      </Modal>
      <AccountInfoModal 
        open={showProfileModal}
        onClose={() => {
          setShowProfileModal(false)
          dispatch(userReducer.signOutUser("customer"))
          setSignInProcess(false)
        }}
      />
    </>
  )
}